import React from 'react'
import Assets from '@lib/Assets'
import IndexTableRow from '@lib/components/index-table/IndexTableRow'

export default class ProjectsTableRow extends IndexTableRow {
    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            configurationsExpanded: false
        }
    }

    onConfigurationsToggleLinkClick = e => {
        this.setState({
            configurationsExpanded: !this.state.configurationsExpanded
        })
    }

    render() {
        return (
            <React.Fragment>
                <tr>
                    {this.renderCheckbox()}
                    {this.props.columns.map((column, idx) => (
                        <React.Fragment key={idx}>
                            {this.renderDataCell(column, this.findValueByColumnSlug(column.meta.slug))}
                        </React.Fragment>
                    ))}
                    {this.renderActionButtons()}
                </tr>

                {this.state.configurationsExpanded ? (
                    <React.Fragment>
                        <tr className="project-details-row">
                            <td className="project-details-row-heading">&nbsp;</td>
                            <td className="project-details-row-heading"></td>
                            <td className="project-details-row-heading">{__('Type')}</td>
                            <td className="project-details-row-heading">{__('Configured by')}</td>
                            <td className="project-details-row-heading">{__('Pricing')}</td>
                            <td className="project-details-row-heading">{__('Last edited')}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>

                        <tr className="project-details-row-contd last">
                            <td></td>
                            <td align="right"></td>
                            <td>Maxi Compact</td>
                            <td></td>
                            <td>
                                Base Unit 1 200 €<br/>
                                Accessories 1 400 €
                            </td>
                            <td>10.12.2018</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </React.Fragment>
                ) : <React.Fragment></React.Fragment>}
            </React.Fragment>
        )
    }

    renderConfigurationsColumn(column, value) {
        value = 1

        return (
            <td>
                {value}
                {value > 0 ? (
                    <div className="project-table-show-configurations-link"
                         onClick={this.onConfigurationsToggleLinkClick}>
                        <span>{this.state.configurationsExpanded ? __('Hide') : __('Show')}</span>
                        <img src={Assets.caret}/>
                    </div>
                ) : ''}
            </td>
        )
    }

    renderStatusColumn(column, value) {
        let slug = ['project', 'rfq', 'quote', 'order']
        let names = ['Project', 'RFQ', 'Quote', 'Order']

        return (
            <td>
                <div className={`project-status-${slug[value]}`}>
                    <span>{names[value]}</span>
                </div>
            </td>
        )
    }

    renderProjectResponsibleColumn(column, value) {
        return (
            <td>{value.fullName}</td>
        )
    }

    renderList(column, value) {
        return (
            <td>
                {value.length === 0 ? (
                    <span className="text-muted">{__('None')}</span>
                ) : value.map(entry => (
                    <div>{entry}</div>
                ))}
            </td>
        )
    }

    renderInvitedViewersColumn = (column, value) => this.renderList(column, value)
    renderInvitedParticipantsColumn = (column, value) => this.renderList(column, value)


}